import { useState } from 'react';

import LegalNoticeGenerator from '../notice/LegalNoticeGenerator';
export default function LegalnoticePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="LegalnoticePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><LegalNoticeGenerator/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
